const t = {
  name: "Person",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2ZM9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7Z" fill="currentColor"/>
<path d="M7 14C4.23858 14 2 16.2386 2 19V22H4V19C4 17.3431 5.34315 16 7 16H17C18.6569 16 20 17.3431 20 19V22H22V19C22 16.2386 19.7614 14 17 14H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Person
};
